import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";
import BookingCarousel from './BookingCarousel';
import InfoGraphic from './InfoGraphic';
import Timeline from './Timeline';
import Video from "./Video";


// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>


			{/* <Popup /> */}

			{/* <Slider /> */}
			<Video />
			<div className="container">
				{/* <Booking /> */}
				{/* <BookingCarousel /> */}
			</div>



			<div className="col-12 col-md-12" style={{ padding: '5px', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
				<div class="container">
					<div className="row">
						<div className="col-md-4">
							<div class="booking-box single">
								<div class="icon">
									<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
								</div>
								<div class="book-btn">
									<a href="#">
										Single Day Pooja <span>➜</span>
									</a>
								</div>

							</div>
						</div>
						<div className="col-md-4">
							<div class="booking-box multiple">
								<div class="icon">
									<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
								</div>
								<div class="book-btn">
									<a href="#">
										Multiple Day Pooja <span>➜</span>
									</a>
								</div>

							</div>
						</div>
						<div className="col-md-4">
							<div class="booking-box ekanikka">
								<div class="icon">
									<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
								</div>
								<div class="book-btn">
									<a href="#">
										E-Kanikka <span>➜</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">

				<div className="col-12 col-md-8" style={{ marginBottom: '50px' }}>


					<div className="">
						<div className="row">
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-4" style={{ backgroundImage: 'url(./images/slider-1.png)', backgroundSize: 'cover', backgroundPosition: 'center', height: '65vh' }}>
											{/* <div className="leftimage">
												<img src="./images/about-left.jpg" />
											</div> */}
										</div>
										<div className="col-md-8">
											<div className="frontbox">
												<p className="historyheadeg">ക്ഷേത്രചരിത്രം</p>
												<p className="frame-1-p">
													കൊടിമൂട്ടിൽ കുടുംബത്തിലെ കാരണവർ മണ്ടയ്ക്കാട്ട് ദേവിയുടെ ഉപാസകനായിരുന്നു. രണ്ട് നൂറ്റാണ്ടുകൾക്ക് മുമ്പ് അന്നത്തെ പുത്തൻവിള പുരയിടത്തിൽ കാട് വെട്ടിതെളിച്ച് കൊണ്ടിരുന്നപ്പോൾ രണ്ട് മൺപുറ്റുകൾ കാണുകയും അതിൽ നിന്നും രക്തം വാർന്ന് ഒഴുകുന്നത് കണ്ട് സംഭീതനായി കുടുംബാംഗങ്ങളോടൊപ്പം പ്രശ്‌നചിന്ത ചെയ്‌ത്‌  ദേവീസാന്നിദ്ധ്യം സ്ഥിരീകരിക്കുകയും ചെയ്തു. തുടർന്ന് മൺപുറ്റ് കണ്ട സ്ഥലത്ത് ആൽത്തറ കെട്ടി പുറ്റിൻമേൽ പൂജകൾ ചെയ്‌ത്‌ ദേവീപ്രീതി വരുത്തി. മണ്ടയ്ക്കാട്ട് ദേവിയുടെ ഉപാസകനായിരുന്ന കാരണവർ തുടർന്ന് മണ്ടയ്ക്കാട്ട് ദേവീ ദർശനത്തിനായി ഇരുമുടികെട്ടുമായി പരിവാരങ്ങളോടൊപ്പം യാത്രയായി. ആൽതറ സ്ഥാപിച്ചിരുന്ന സ്ഥലത്ത് പിൽക്കാലത്ത് ക്ഷേത്രം നിർമ്മിക്കുകയും കുടുംബകാരണവർ സ്വന്തം കൈകൊണ്ട് മെനഞ്ഞെടുത്ത ദേവിയുടെ കളി മൺ വിഗ്രഹം മൺപുറ്റുകൾക്ക് പിന്നിലായി പ്രതിഷ്‌ഠിക്കുകയും ചെയ്‌തു.
												</p>

												<Link to="/History" className="btn btn-warning pos">Read More</Link>
											</div>
										</div>

									</div>
								</div>
							</div>

						</div>
					</div>

				</div>
				<div className="col-md-4" style={{backgroundImage: 'url(./images/slider-1.png)',backgroundSize:'cover',backgroundPosition:'center',backgroundAttachment:'fixed'}}>
					
				</div>
			</div>
			<div className="row" style={{ backgroundImage: 'url(./images/slider-1.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
				<div style={{ background: 'rgba(29, 0, 0, 0.6)' }}>
					<h1 style={{ color: 'white', background: 'maroon', borderBottom: '1px solid white', padding: '25px', fontFamily: 'anek malayalam', fontSize: '22pt' }}>പ്രധാനപ്പെട്ട വഴിപാടുകള്‍</h1>
					<Timeline />
				</div>
			</div>
		</div>

	);
}

export default Home;